/**
 * Recent searches — stored in localStorage, capped at 5 entries.
 * Most-recent first. Empty/whitespace terms are ignored. Powers the
 * command palette suggestions (Phase 7 success #3).
 */

const KEY = "bargain-radar:recent-searches";
const MAX = 5;

export function getRecentSearches(): string[] {
  if (typeof localStorage === "undefined") return [];
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) {
      return parsed.filter((x) => typeof x === "string").slice(0, MAX);
    }
    return [];
  } catch {
    return [];
  }
}

export function addRecentSearch(term: string): void {
  const t = term.trim();
  if (!t) return;
  if (typeof localStorage === "undefined") return;
  const current = getRecentSearches();
  const next = [t, ...current.filter((x) => x.toLowerCase() !== t.toLowerCase())].slice(0, MAX);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* ignore quota errors */
  }
}

export function clearRecentSearches(): void {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
